import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedNumber } from 'react-intl';
import { Box } from '@mui/material';
import { GridActionsCellItem, type GridColDef } from '@mui/x-data-grid-premium';

import { type ViewPageContentTabProps } from 'app/main/components/page-layouts/view/ViewPage';
import { Icon, showDeleteDialog, TabFab, useSettings } from 'app/main/components';
import { ViewTable, ViewTableUtils } from 'app/main/components/page-layouts';

import { showItemMerchPointsEditLineDialog } from '../../components/ItemMerchPointsEditLineDialog';

type ItemsMerchandiseTabProps = Pick<ViewPageContentTabProps, 'refresh' | 'updateRefresh'>;

export default function ItemsMerchandiseTab(props: ItemsMerchandiseTabProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	function addNewItemMerch() {
		dispatch(showItemMerchPointsEditLineDialog({ isAdd: true, updateRefresh: props.updateRefresh }));
	}

	function openEditLineDialog(row) {
		dispatch(showItemMerchPointsEditLineDialog({ baseModel: row, updateRefresh: props.updateRefresh }));
	}

	function deleteLine({ id, title }) {
		dispatch(
			showDeleteDialog({
				module: 'items_merchpoints',
				id,
				title,
				updateRefresh: props.updateRefresh,
				hardDelete: true,
				replace: false
			})
		);
	}

	const columns: GridColDef[] = [
		{
			field: 'item_erp_id',
			headerName: t('DETAILS_ITEMS_FIELD_ERP_ID'),
			minWidth: 120
		},
		{
			field: 'item_title',
			headerName: t('MODULE_ITEMS_NAME_SINGULAR'),
			minWidth: 200,
			flex: 1,
			renderCell: ({ value, row }) =>
				ViewTableUtils.renderCellWithTooltip({ value, to: { module: 'items', uid: row.item_uid } }),
			hideable: false
		},
		{
			field: 'itmp_d_from',
			headerName: t('DETAILS_ITEMS_MERCHPOINTS_FIELD_DATE_FROM'),
			minWidth: 125,
			renderCell: ViewTableUtils.renderDate,
			hideable: false
		},
		{
			field: 'itmp_d_to',
			headerName: t('DETAILS_ITEMS_MERCHPOINTS_FIELD_DATE_TO'),
			minWidth: 125,
			renderCell: ViewTableUtils.renderDate,
			hideable: false
		},
		{
			field: 'pric_title',
			headerName: t('DETAILS_ITEMS_MERCHPOINTS_FIELD_PRICING_GROUP'),
			minWidth: 200,
			renderCell: ViewTableUtils.renderCellWithTooltip,
			hideable: false
		},
		{
			field: 'itmp_points_price',
			type: 'number',
			headerName: t('DETAILS_ITEMS_MERCHPOINTS_FIELD_POINTS'),
			minWidth: 100,
			renderCell: ({ value }) => <FormattedNumber value={-value} signDisplay="exceptZero" />,
			hideable: false
		}
		// {
		// 	field: 'actions',
		// 	type: 'actions',
		// 	width: 80,
		// 	getActions: ({ row }) => [
		// 		<GridActionsCellItem
		// 			label={t('VIEW_ITEM_BUTTON_EDIT')}
		// 			icon={<Icon icon="edit" />}
		// 			onClick={() => openEditLineDialog(row)}
		// 		/>,
		// 		<GridActionsCellItem
		// 			label={t('VIEW_ITEM_BUTTON_DELETE')}
		// 			icon={<Icon icon="delete" />}
		// 			onClick={() => deleteLine({ id: row.itmp_uid, title: row.itmp_title })}
		// 		/>
		// 	]
		// }
	];

	return (
		<Box className="w-full">
			<ViewTable
				module="items_merchpoints"
				columns={columns}
				defaultFilters={[
					{
						filt_field: 'item_blocked',
						filt_clause: 'not_equal',
						filt_value: 1
					}
				]}
				refresh={props.refresh}
				updateRefresh={props.updateRefresh}
			/>
			{/* <TabFab label={t('ITEMS_MERCHPOINTS_ADD_DIALOG_TITLE')} icon="add-circle" onClick={addNewItemMerch} /> */}
		</Box>
	);
}
